const exports = {
  remSize: '16px',
  goodOT: 'GoodOT',
  goodOTCond: 'GoodOTCond',
  goodOTNarrow: 'GoodOTNarrow',
  sourceSansPro: 'Source Sans Pro',
}

export default exports
